import { createStore } from 'zustand/vanilla';
import { devtools } from 'zustand/middleware';
import getCartQueryKey from '@nike/shop-apis/buy/carts/v2/get-query-key';
import getListItems from '@nike/shop-apis/buy/wishlists/v2/helpers/get-list-items';
import trackEvent from "../../analytics/track-event";
var DESIGN_VIEW_INSTRUCTION_TYPES = ['customization/nike_id', 'customization/jersey_id'];
var createItemAddedModalStore = function createItemAddedModalStore() {
  return createStore(devtools(function (set) {
    return {
      productId: '',
      // For cart (UUID format)
      productCode: '',
      itemId: '',
      designViewId: '',
      modalType: null,
      // 'cart' | 'favorites' | null
      toggleModal: function toggleModal(_ref) {
        var type = _ref.type;
        return set(function (state) {
          var _queryClient$getQuery, _firstCartItem$valueA, _appliedDesignViewVas;
          // If already open, close it
          if ((state.productId || state.productCode) && state.itemId) {
            return {
              productId: '',
              productCode: '',
              itemId: '',
              designViewId: '',
              modalType: null
            };
          }

          // If not closing, we're opening it
          trackEvent('nike-shop-atc-modal', null, {
            telemetryData: {
              modalType: type
            },
            usePageAction: true
          });
          var queryClient = window.NikeShop.__INTERNAL_USE__.queryClient;

          // Favorites is the simpler case — just need the item id and style color
          if (type === 'favorites') {
            var listItems = getListItems({
              queryClient: queryClient
            }) || [];
            var firstListItem = listItems[0] || {};
            return {
              productCode: firstListItem.productCode || '',
              itemId: firstListItem.id || '',
              modalType: type,
              // set to empty to keep state clean
              designViewId: '',
              productId: ''
            };
          }

          // Cart additionally needs to resolve a design view for customized products
          var firstCartItem = ((_queryClient$getQuery = queryClient.getQueryData(getCartQueryKey())) === null || _queryClient$getQuery === void 0 || (_queryClient$getQuery = _queryClient$getQuery.items) === null || _queryClient$getQuery === void 0 ? void 0 : _queryClient$getQuery[0]) || {};
          var appliedDesignViewVas = firstCartItem === null || firstCartItem === void 0 || (_firstCartItem$valueA = firstCartItem.valueAddedServices) === null || _firstCartItem$valueA === void 0 ? void 0 : _firstCartItem$valueA.find(function (vas) {
            var _vas$instruction;
            return DESIGN_VIEW_INSTRUCTION_TYPES.includes(vas === null || vas === void 0 || (_vas$instruction = vas.instruction) === null || _vas$instruction === void 0 ? void 0 : _vas$instruction.type);
          });
          var data = {
            productId: firstCartItem.productId || '',
            productCode: firstCartItem.productCode || '',
            itemId: firstCartItem.id || '',
            designViewId: (appliedDesignViewVas === null || appliedDesignViewVas === void 0 || (_appliedDesignViewVas = appliedDesignViewVas.instruction) === null || _appliedDesignViewVas === void 0 ? void 0 : _appliedDesignViewVas.id) || '',
            modalType: type
          };
          return data;
        });
      },
      closeModal: function closeModal() {
        return set(function () {
          return {
            productId: '',
            productCode: '',
            itemId: '',
            designViewId: '',
            modalType: null
          };
        });
      }
    };
  }, {
    name: 'NikeShop - Item Added Modal',
    enabled: process.env.NODE_ENV === 'development'
  }));
};
export default createItemAddedModalStore;